import script from "./Message.vue?vue&type=script&setup=true&lang=js"
export * from "./Message.vue?vue&type=script&setup=true&lang=js"

import "./Message.vue?vue&type=style&index=0&id=0ea2de72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea2de72"]])

export default __exports__